import * as e from "react";
import { forwardRef as o } from "react";
const i = o(function(l, t) {
  return /* @__PURE__ */ e.createElement(
    "svg",
    {
      fill: "none",
      ref: t,
      viewBox: "0 0 24 24",
      xmlns: "http://www.w3.org/2000/svg",
      ...l
    },
    /* @__PURE__ */ e.createElement(
      "path",
      {
        clipRule: "evenodd",
        d: "M19 5H11.3V7.75H16.25V12.7H19V5ZM15.5 8.5H7.8V11.25H12.75V16.2H15.5V8.5ZM5 12H12V19H5V12Z",
        fill: "currentColor",
        fillRule: "evenodd"
      }
    )
  );
});
export {
  i as Multiples
};
